import { apiClient, Auth } from '@/shared/api'

import { TRoomAvailableWeeks } from '../model/schema'

export type RoomAvailableWeeksParams = {
  roomId: number
  startDate: string
  isExtend?: boolean
}

export const getRoomAvailableWeeks = async ({
  roomId,
  startDate,
  isExtend = false,
}: RoomAvailableWeeksParams) => {
  const { data } = await apiClient.get<TRoomAvailableWeeks>({
    endpoint: `/rooms/${roomId}/available-weeks`,
    queryParams: { startDate, isExtend },
    auth: Auth.REQUIRED,
  })

  return data
}
